import Loadable from '../../../components/loadable';

export default Loadable(() =>
    import(/* webpackChunkName: "listframe" */ './index')
);
